import React from 'react';

const Keywords = ({ keywords, label = 'Keywords:' }) => {
  if (!Array.isArray(keywords) || keywords.length === 0) return null;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', marginBottom: '10px' }}>
      <strong>{label}</strong>
      {keywords.map((keyword, index) => (
        <span
          key={`${keyword}-${index}`}
          style={{
            backgroundColor: '#4caf50',
            color: '#fff',
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '12px'
          }}
        >
          {keyword}
        </span>
      ))}
    </div>
  );
};

export default Keywords;


